import { Col, Flex, FormListFieldData, Row, Space } from "antd";
import { CircleTick, DeleteIcon, DownloadIcon, EditIcon } from "../assets";
import { IconPrimary } from "../components";
import downloadFile from "../utils/downloadFile";

type Props = {
  field: FormListFieldData;
  form: any;
  onDelete: (index: number | number[]) => void;
  onEdit: (key: number) => void;
};

const QuestionFormData: React.FC<Props> = ({
  field,
  form,
  onDelete,
  onEdit,
}: Props) => {
  const type = form.getFieldValue(["questions", field.name, "type"]);
  const options = form.getFieldValue(["questions", field.name, "option"]);
  const answer = form.getFieldValue(["questions", field.name, "answer"]);

  return (
    <>
      <div className="full-width-div">
        <h5>{`Question ${field.name + 1} .`}</h5>
      </div>
      <Flex style={{ margin: "20px 0" }} justify="end">
        <Space>
          {form.getFieldValue(["questions", field.name, "file"]) ? (
            <div
              className="pill_primary"
              onClick={() =>
                downloadFile(
                  form.getFieldValue(["questions", field.name, "file"]),
                  "question"
                )
              }
            >
              <Row align={"middle"}>
                <span style={{ marginRight: 10 }}>File</span>
                <DownloadIcon />
              </Row>
            </div>
          ) : null}

          <div className="pill_primary">
            {type === "mcq" ? "Correct Option" : "Flag"} : {answer}
          </div>

          <div className="pill_primary">
            Score : {form.getFieldValue(["questions", field.name, "score"])}
          </div>

          <IconPrimary onClick={() => onEdit(field.key)}>
            <EditIcon />
          </IconPrimary>

          <IconPrimary onClick={() => onDelete(field.name)}>
            <DeleteIcon />
          </IconPrimary>
        </Space>
      </Flex>
      <div className="question_description ">
        {form.getFieldValue(["questions", field.name, "description"])}
      </div>
      {type === "mcq" ? (
        <Row gutter={[20, 20]} style={{ marginTop: 20 }}>
          {options.map((option: any, index: number) => {
            const isCorrect = Boolean(option) && option === answer;
            return (
              <Col span={12} key={index}>
                <Flex flex={1} align="center" gap={10}>
                  <label>{`Option ${index + 1}`}</label>
                  <p
                    className="question_description"
                    style={{
                      fontSize: 14,
                      flex: 1,
                      ...(isCorrect
                        ? {
                            border: "1px solid #3FB950",
                            color: "#ffffff",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            gap: 10,
                          }
                        : null),
                    }}
                  >
                    {option}
                    {isCorrect ? (
                      <CircleTick
                        className="correct_option_tick"
                        aria-label="Correct option"
                      />
                    ) : null}
                  </p>
                </Flex>
              </Col>
            );
          })}
        </Row>
      ) : null}
    </>
  );
};

export default QuestionFormData;
